module.exports = __webpack_public_path__ + "img/icon_trash.25c17e43.svg";